import bridge from '@vkontakte/vk-bridge'

const hideBannerAd = (): void => {
  bridge.send('VKWebAppHideBannerAd', {})
}

export default hideBannerAd
